<th class="border-bold-left" [class.italic]="headerItalic" scope="row"
  [innerHTML]="'m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.table.rowheader.' + key | translate">
</th>
@for (column of columns; track column; let last = $last) {
  <td class="border-bold-left text-align-right" [ngClass]="{'border-bold-right shaded': last}">
    @if (key ==='freiheitsgrade' || key ==='anzahlAusschluesse' || key ==='n') {
      {{data[column][key] | numberFormat: crtLocale}}
    }
    @if (key ==='sigDiff0' || key ==='sigDiff5') {
      {{data[column][key] | boolToYesNo}}
    }
    @if (key ==='pWert') {
      {{data[column][key] | numberFormat: crtLocale:4}}
    }
    @if (key ==='geschlechtskoeffizient' || key ==='teststatistik' || key ==='standardfehler' || key ==='KIUntergrenze' || key ==='KIObergrenze' || key ==='r2') {
      {{data[column][key] | numberFormat: crtLocale:3}}
    }
  </td>
}
